export default "__VITE_ASSET__651378a5__"